module.exports = __webpack_public_path__ + "img/xianjiaotong.e0459cef.jpg";